__turbopack_context__.v({
  "className": "open_sans_ff0c7d53-module__ewuT0a__className",
  "variable": "open_sans_ff0c7d53-module__ewuT0a__variable",
});
